import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          consent: {
            title: 'Before you browse',
            body: 'We use cookies from Meta and Google to see which of our adverts bring students to this site. They are not needed for the site to work, and your application details are never shared.',
            privacy: 'Read our privacy notice',
            accept: 'Accept',
            decline: 'Decline',
            label: 'Tracking consent',
          },
          seo: {
            title: 'San Tomas Tourism College - Premier Education in Nairobi',
            description: 'Join San Tomas Tourism College in Nairobi for top-tier courses in Language, Hospitality, Business, and IT. Explore our programs and apply today!',
            keywords: 'San Tomas Tourism College, Nairobi college, hospitality courses, language school, business diploma, IT certification',
            ogTitle: 'San Tomas Tourism College - Premier Education in Nairobi',
            ogDescription: 'Top-tier tourism education with industry-focused programs in Nairobi',
          },
          a11y: {
            skipToContent: 'Skip to main content',
            campusSlideshow: 'Campus highlights slideshow',
            goToSlide: 'Go to slide {{index}}',
            switchToEnglish: 'Switch to English',
            switchToSwahili: 'Switch to Swahili',
            switchToFrench: 'Switch to French',
            switchToSpanish: 'Switch to Spanish',
            viewAllPrograms: 'View all academic programs',
          },
          hero: {
            tagline: 'Premier Tourism Education Since 1997',
            title: 'Shape Your Future in',
            subtitle: 'Global Tourism & Hospitality',
            description: 'Join Kenya\'s leading tourism college for internationally recognized qualifications and a 95% employment rate.',
            apply: 'Apply Today',
            applyAria: 'Apply to San Tomas Tourism College',
            explore: 'Explore Programs',
            exploreAria: 'Explore Programs',
            stat1: '95% Graduate Employment',
            stat2: 'International Certifications',
          },
          purpose: {
            title: 'Our Purpose',
            mission: 'Mission',
            missionText: 'To provide knowledge, skills, and competence in Hospitality, Business Studies, IT, and Foreign Languages.',
            vision: 'Vision',
            visionText: 'High-quality training for academic excellence and professional development, enabling global opportunities.',
            values: 'Core Values',
            valuesText: 'Honesty, transparency, good governance, integrity, respect, and commitment.',
          },
          courses: {
            title: 'Featured Programs',
            duration: 'Duration',
            feePerLevel: 'Fee per Level',
            feePerTerm: 'Fee per Term',
            admissionFee: 'Admission Fee',
            examinationFee: 'Examination Fee',
            nonRefundable: 'non-refundable',
            learnMore: 'Learn more',
            learnMoreAria: 'Learn more about {{name}}',
            viewAll: 'View All Programs',
          },
          faculty: {
            title: 'Faculty Spotlights',
          },
          alumni: {
            title: 'Alumni Network',
            description: 'Our alumni network spans the globe, with graduates excelling in hospitality, business, IT, and language fields. Inspired by our motto "Illuminatio et Salus Populi," they embody the college’s mission to enlighten and empower. Connect with success stories and join a community dedicated to professional growth and global impact.',
            comingSoon: 'Coming soon: Alumni testimonials and networking events!',
            viewAll: 'Discover Alumni Stories',
            viewAllAria: 'View all alumni stories',
          },
          contact: {
            title: 'Get in Touch',
            address: 'Address',
            addressDetails: 'Information House, 2nd Floor, Nairobi CBD',
            phone: 'Phone',
            email: 'Email',
            interestTitle: 'Express Your Interest',
            interestText: 'Interested in joining us? Leave your details below, and we’ll get in touch!',
          },
          form: {
            name: 'Name',
            telephone: 'Telephone',
            email: 'Email',
            nameRequired: 'Name is required',
            telephoneRequired: 'Telephone is required',
            telephoneFormat: 'Telephone must be in the format +2547XXXXXXXX or +2541XXXXXXXX',
            emailRequired: 'Email is required',
            emailInvalid: 'Invalid email address',
            submit: 'Submit Interest',
            submitting: 'Submitting...',
            submitInterest: 'Submit interest form',
            success: 'Thank you for your interest!',
            successDetails: 'Our admissions team will contact you shortly.',
            submitAnother: 'Submit another response',
            error: 'Failed to submit. Please try again later.',
          },
          footer: {
            motto: 'Illuminatio et Salus Populi',
            quality: 'Providing quality tourism education since 1997',
            location: 'Location & Contact',
            address: 'Information House, 2nd Floor',
            nairobi: 'Nairobi CBD, Kenya',
            hours: 'Current Time',
            cookieSettings: 'Cookie settings',
            privacy: 'Privacy notice',
            copyright: 'San Tomas Tourism College. All rights reserved.',
            admin: 'Admin Dashboard',
            adminAria: 'Access the admin dashboard',
          },
          nav: {
            home: 'Home',
            programs: 'Programs',
            campusLife: 'Campus Life',
            alumni: 'Alumni',
            enrollment: 'Enrollment',
          },
          lang: {
            en: 'EN',
            sw: 'SW',
            fr: 'FR',
            es: 'ES',
          },
        },
      },
      sw: {
        translation: {
          consent: {
            title: 'Kabla hujaendelea',
            body: 'Tunatumia vidakuzi kutoka Meta na Google kuona ni matangazo yetu gani yanayoleta wanafunzi kwenye tovuti hii. Havihitajiki ili tovuti ifanye kazi, na maelezo ya maombi yako hayashirikiwi kamwe.',
            privacy: 'Soma taarifa yetu ya faragha',
            accept: 'Kubali',
            decline: 'Kataa',
            label: 'Idhini ya ufuatiliaji',
          },
          seo: {
            title: 'Chuo cha Utalii cha San Tomas - Elimu ya Juu huko Nairobi',
            description: 'Jiunge na Chuo cha Utalii cha San Tomas huko Nairobi kwa kozi za kiwango cha juu za Lugha, Ukarimu, Biashara, na IT. Chunguza programu zetu na ujiunge leo!',
            keywords: 'Chuo cha Utalii cha San Tomas, Chuo cha Nairobi, kozi za ukarimu, shule ya lugha, diploma ya biashara, cheti cha IT',
            ogTitle: 'Chuo cha Utalii cha San Tomas - Elimu ya Juu huko Nairobi',
            ogDescription: 'Elimu ya kiwango cha juu ya utalii na programu zinazolenga sekta huko Nairobi',
          },
          a11y: {
            skipToContent: 'Ruka hadi maudhui ya msingi',
            campusSlideshow: 'Onyesho la slaidi za mambo ya chuo',
            goToSlide: 'Nenda kwenye slaidi {{index}}',
            switchToEnglish: 'Badilisha hadi Kiingereza',
            switchToSwahili: 'Badilisha hadi Kiswahili',
            switchToFrench: 'Badilisha hadi Kifaransa',
            switchToSpanish: 'Badilisha hadi Kihispania',
            viewAllPrograms: 'Angalia programu zote za kitaaluma',
          },
          hero: {
            tagline: 'Elimu ya Utalii ya Juu Tangu 1997',
            title: 'Chagiza Mustakabali Wako katika',
            subtitle: 'Utalii na Ukarimu wa Kimataifa',
            description: 'Jiunge na chuo cha utalii kinachoongoza nchini Kenya kwa sifa zinazotambuliwa kimataifa na kiwango cha ajira cha 95%.',
            apply: 'Tuma Ombi Leo',
            applyAria: 'Tuma ombi kwa Chuo cha Utalii cha San Tomas',
            explore: 'Chunguza Programu',
            exploreAria: 'Chunguza Programu',
            stat1: 'Ajira ya Wahitimu 95%',
            stat2: 'Vyeti vya Kimataifa',
          },
          purpose: {
            title: 'Kusudi Letu',
            mission: 'Dhamira',
            missionText: 'Kutoa maarifa, ujuzi, na umahiri katika Ukarimu, Masomo ya Biashara, IT, na Lugha za Kigeni.',
            vision: 'Maono',
            visionText: 'Mafunzo ya ubora wa juu kwa ubora wa kitaaluma na maendeleo ya kitaalamu, yanayowezesha fursa za kimataifa.',
            values: 'Maadili ya Msingi',
            valuesText: 'Uaminifu, uwazi, utawala bora, uadilifu, heshima, na kujitolea.',
          },
          courses: {
            title: 'Programu Zilizochaguliwa',
            duration: 'Muda',
            feePerLevel: 'Ada kwa Kila Ngazi',
            feePerTerm: 'Ada kwa Kila Muhula',
            admissionFee: 'Ada ya Kujiunga',
            examinationFee: 'Ada ya Mitihani',
            nonRefundable: 'isiyorudishwa',
            learnMore: 'Jifunze zaidi',
            learnMoreAria: 'Jifunze zaidi kuhusu {{name}}',
            viewAll: 'Angalia Programu Zote',
          },
          faculty: {
            title: 'Wahadhiri Wanaochaguliwa',
          },
          alumni: {
            title: 'Mtandao wa Wanachuo Waliomaliza',
            description: 'Mtandao wetu wa wanachuo waliomaliza unavuka dunia, na wahitimu wakifanya vizuri katika ukarimu, biashara, IT, na nyanja za lugha. Wakiongozwa na kauli mbiu yetu "Illuminatio et Salus Populi," wao ni mfano wa dhamira ya chuo ya kuangaza na kuwezesha. Jiunge na hadithi za mafanikio na ujiunge na jamii inayojitolea kwa ukuaji wa kitaalamu na athari za kimataifa.',
            comingSoon: 'Hivi karibuni: Ushuhuda wa wanachuo waliomaliza na matukio ya mtandao!',
            viewAll: 'Gundua Hadithi za Wanachuo Waliomaliza',
            viewAllAria: 'Angalia hadithi zote za wanachuo waliomaliza',
          },
          contact: {
            title: 'Wasiliana Nasi',
            address: 'Anwani',
            addressDetails: 'Nyumba ya Taarifa, Ghorofa ya Pili, Nairobi CBD',
            phone: 'Simu',
            email: 'Barua Pepe',
            interestTitle: 'Onyesha Nia Yako',
            interestText: 'Unavutiwa na kujiunga nasi? Acha maelezo yako hapa chini, na tutawasiliana nawe!',
          },
          form: {
            name: 'Jina',
            telephone: 'Simu',
            email: 'Barua Pepe',
            nameRequired: 'Jina linahitajika',
            telephoneRequired: 'Simu inahitajika',
            telephoneFormat: 'Simu inapaswa kuwa katika muundo +2547XXXXXXXX au +2541XXXXXXXX',
            emailRequired: 'Barua pepe inahitajika',
            emailInvalid: 'Anwani ya barua pepe si sahihi',
            submit: 'Tuma Nia',
            submitting: 'Inatumwa...',
            submitInterest: 'Tuma fomu ya nia',
            success: 'Asante kwa nia yako!',
            successDetails: 'Timu yetu ya uandikishaji itawasiliana nawe hivi karibuni.',
            submitAnother: 'Tuma jibu lingine',
            error: 'Imeshindwa kutuma. Tafadhali jaribu tena baadaye.',
          },
          footer: {
            motto: 'Illuminatio et Salus Populi',
            quality: 'Kutoa elimu ya utalii ya ubora tangu 1997',
            location: 'Mahali na Mawasiliano',
            address: 'Nyumba ya Taarifa, Ghorofa ya Pili',
            nairobi: 'Nairobi CBD, Kenya',
            hours: 'Saa za Sasa',
            cookieSettings: 'Mipangilio ya vidakuzi',
            privacy: 'Taarifa ya faragha',
            copyright: 'Chuo cha Utalii cha San Tomas. Haki zote zimehifadhiwa.',
            admin: 'Dashibodi ya Msimamizi',
            adminAria: 'Fikia dashibodi ya msimamizi',
          },
          nav: {
            home: 'Nyumbani',
            programs: 'Programu',
            campusLife: 'Maisha ya Chuo',
            alumni: 'Wanachuo Waliomaliza',
            enrollment: 'Uandikishaji',
          },
          lang: {
            en: 'EN',
            sw: 'SW',
            fr: 'FR',
            es: 'ES',
          },
        },
      },
      fr: {
        translation: {
          consent: {
            title: 'Avant de continuer',
            body: 'Nous utilisons des cookies de Meta et Google pour savoir quelles publicités amènent des étudiants sur ce site. Ils ne sont pas nécessaires au fonctionnement du site, et les informations de votre candidature ne sont jamais partagées.',
            privacy: 'Lire notre politique de confidentialité',
            accept: 'Accepter',
            decline: 'Refuser',
            label: 'Consentement au suivi',
          },
          seo: {
            title: 'Collège de Tourisme San Tomas - Éducation de Premier Plan à Nairobi',
            description: 'Rejoignez le Collège de Tourisme San Tomas à Nairobi pour des cours de haut niveau en langues, hôtellerie, commerce et informatique. Explorez nos programmes et postulez aujourd’hui !',
            keywords: 'Collège de Tourisme San Tomas, collège de Nairobi, cours d’hôtellerie, école de langues, diplôme de commerce, certification en informatique',
            ogTitle: 'Collège de Tourisme San Tomas - Éducation de Premier Plan à Nairobi',
            ogDescription: 'Éducation touristique de premier plan avec des programmes axés sur l’industrie à Nairobi',
          },
          a11y: {
            skipToContent: 'Passer au contenu principal',
            campusSlideshow: 'Diaporama des moments forts du campus',
            goToSlide: 'Aller à la diapositive {{index}}',
            switchToEnglish: 'Passer à l’anglais',
            switchToSwahili: 'Passer au swahili',
            switchToFrench: 'Passer au français',
            switchToSpanish: 'Passer à l’espagnol',
            viewAllPrograms: 'Voir tous les programmes académiques',
          },
          hero: {
            tagline: 'Éducation Touristique de Premier Plan Depuis 1997',
            title: 'Façonnez Votre Avenir dans',
            subtitle: 'Tourisme et Hôtellerie Mondiaux',
            description: 'Rejoignez le principal collège de tourisme du Kenya pour des qualifications reconnues internationalement et un taux d’emploi de 95%.',
            apply: 'Postulez Aujourd’hui',
            applyAria: 'Postuler au Collège de Tourisme San Tomas',
            explore: 'Explorer les Programmes',
            exploreAria: 'Explorer les Programmes',
            stat1: '95% d’Emploi des Diplômés',
            stat2: 'Certifications Internationales',
          },
          purpose: {
            title: 'Notre Objectif',
            mission: 'Mission',
            missionText: 'Fournir des connaissances, des compétences et des compétences en hôtellerie, études commerciales, informatique et langues étrangères.',
            vision: 'Vision',
            visionText: 'Formation de haute qualité pour l’excellence académique et le développement professionnel, permettant des opportunités mondiales.',
            values: 'Valeurs Fondamentales',
            valuesText: 'Honnêteté, transparence, bonne gouvernance, intégrité, respect et engagement.',
          },
          courses: {
            title: 'Programmes en Vedette',
            duration: 'Durée',
            feePerLevel: 'Frais par Niveau',
            feePerTerm: 'Frais par Trimestre',
            admissionFee: 'Frais d’Admission',
            examinationFee: 'Frais d’Examen',
            nonRefundable: 'non remboursable',
            learnMore: 'En savoir plus',
            learnMoreAria: 'En savoir plus sur {{name}}',
            viewAll: 'Voir Tous les Programmes',
          },
          faculty: {
            title: 'Focus sur les Enseignants',
          },
          alumni: {
            title: 'Réseau des Anciens Élèves',
            description: 'Notre réseau d’anciens élèves s’étend à travers le monde, avec des diplômés excellant dans les domaines de l’hôtellerie, du commerce, de l’informatique et des langues. Inspirés par notre devise « Illuminatio et Salus Populi », ils incarnent la mission du collège d’éclairer et de responsabiliser. Connectez-vous avec des histoires de succès et rejoignez une communauté dédiée à la croissance professionnelle et à l’impact mondial.',
            comingSoon: 'Bientôt : Témoignages d’anciens élèves et événements de réseautage !',
            viewAll: 'Découvrir les Histoires des Anciens Élèves',
            viewAllAria: 'Voir toutes les histoires des anciens élèves',
          },
          contact: {
            title: 'Contactez-Nous',
            address: 'Adresse',
            addressDetails: 'Maison de l’Information, 2ème Étage, Nairobi CBD',
            phone: 'Téléphone',
            email: 'Email',
            interestTitle: 'Exprimez Votre Intérêt',
            interestText: 'Intéressé à nous rejoindre ? Laissez vos coordonnées ci-dessous, et nous vous contacterons !',
          },
          form: {
            name: 'Nom',
            telephone: 'Téléphone',
            email: 'Email',
            nameRequired: 'Le nom est requis',
            telephoneRequired: 'Le téléphone est requis',
            telephoneFormat: 'Le téléphone doit être au format +2547XXXXXXXX ou +2541XXXXXXXX',
            emailRequired: 'L’email est requis',
            emailInvalid: 'Adresse email invalide',
            submit: 'Soumettre l’Intérêt',
            submitting: 'Envoi en cours...',
            submitInterest: 'Soumettre le formulaire d’intérêt',
            success: 'Merci pour votre intérêt !',
            successDetails: 'Notre équipe d’admission vous contactera sous peu.',
            submitAnother: 'Soumettre une autre réponse',
            error: 'Échec de la soumission. Veuillez réessayer plus tard.',
          },
          footer: {
            motto: 'Illuminatio et Salus Populi',
            quality: 'Offrir une éducation touristique de qualité depuis 1997',
            location: 'Emplacement et Contact',
            address: 'Maison de l’Information, 2ème Étage',
            nairobi: 'Nairobi CBD, Kenya',
            hours: 'Heure Actuelle',
            cookieSettings: 'Paramètres des cookies',
            privacy: 'Politique de confidentialité',
            copyright: 'Collège de Tourisme San Tomas. Tous droits réservés.',
            admin: 'Tableau de Bord Admin',
            adminAria: 'Accéder au tableau de bord admin',
          },
          nav: {
            home: 'Accueil',
            programs: 'Programmes',
            campusLife: 'Vie sur le Campus',
            alumni: 'Anciens Élèves',
            enrollment: 'Inscription',
          },
          lang: {
            en: 'EN',
            sw: 'SW',
            fr: 'FR',
            es: 'ES',
          },
        },
      },
      es: {
        translation: {
          consent: {
            title: 'Antes de continuar',
            body: 'Usamos cookies de Meta y Google para saber qué anuncios traen estudiantes a este sitio. No son necesarias para que el sitio funcione, y los datos de tu solicitud nunca se comparten.',
            privacy: 'Lee nuestro aviso de privacidad',
            accept: 'Aceptar',
            decline: 'Rechazar',
            label: 'Consentimiento de seguimiento',
          },
          seo: {
            title: 'Colegio de Turismo San Tomas - Educación de Primer Nivel en Nairobi',
            description: 'Únete al Colegio de Turismo San Tomas en Nairobi para cursos de alto nivel en Idiomas, Hospitalidad, Negocios e Informática. ¡Explora nuestros programas y solicita hoy!',
            keywords: 'Colegio de Turismo San Tomas, colegio de Nairobi, cursos de hospitalidad, escuela de idiomas, diploma de negocios, certificación en informática',
            ogTitle: 'Colegio de Turismo San Tomas - Educación de Primer Nivel en Nairobi',
            ogDescription: 'Educación turística de primer nivel con programas enfocados en la industria en Nairobi',
          },
          a11y: {
            skipToContent: 'Saltar al contenido principal',
            campusSlideshow: 'Presentación de diapositivas de los aspectos destacados del campus',
            goToSlide: 'Ir a la diapositiva {{index}}',
            switchToEnglish: 'Cambiar a inglés',
            switchToSwahili: 'Cambiar a suajili',
            switchToFrench: 'Cambiar a francés',
            switchToSpanish: 'Cambiar a español',
            viewAllPrograms: 'Ver todos los programas académicos',
          },
          hero: {
            tagline: 'Educación Turística de Primer Nivel Desde 1997',
            title: 'Da Forma a Tu Futuro en',
            subtitle: 'Turismo y Hospitalidad Global',
            description: 'Únete al principal colegio de turismo de Kenia para obtener calificaciones reconocidas internacionalmente y una tasa de empleo del 95%.',
            apply: 'Solicita Hoy',
            applyAria: 'Solicitar al Colegio de Turismo San Tomas',
            explore: 'Explorar Programas',
            exploreAria: 'Explorar Programas',
            stat1: '95% de Empleo de Graduados',
            stat2: 'Certificaciones Internacionales',
          },
          purpose: {
            title: 'Nuestro Propósito',
            mission: 'Misión',
            missionText: 'Proporcionar conocimientos, habilidades y competencias en Hospitalidad, Estudios de Negocios, Informática e Idiomas Extranjeros.',
            vision: 'Visión',
            visionText: 'Formación de alta calidad para la excelencia académica y el desarrollo profesional, habilitando oportunidades globales.',
            values: 'Valores Fundamentales',
            valuesText: 'Honestidad, transparencia, buena gobernanza, integridad, respeto y compromiso.',
          },
          courses: {
            title: 'Programas Destacados',
            duration: 'Duración',
            feePerLevel: 'Tarifa por Nivel',
            feePerTerm: 'Tarifa por Trimestre',
            admissionFee: 'Tarifa de Admisión',
            examinationFee: 'Tarifa de Examen',
            nonRefundable: 'no reembolsable',
            learnMore: 'Aprende más',
            learnMoreAria: 'Aprende más sobre {{name}}',
            viewAll: 'Ver Todos los Programas',
          },
          faculty: {
            title: 'Destacados del Profesorado',
          },
          alumni: {
            title: 'Red de Egresados',
            description: 'Nuestra red de egresados abarca el mundo, con graduados destacándose en hospitalidad, negocios, informática e idiomas. Inspirados por nuestro lema "Illuminatio et Salus Populi", encarnan la misión del colegio de iluminar y empoderar. Conéctate con historias de éxito y únete a una comunidad dedicada al crecimiento profesional y al impacto global.',
            comingSoon: '¡Próximamente: Testimonios de egresados y eventos de networking!',
            viewAll: 'Descubrir Historias de Egresados',
            viewAllAria: 'Ver todas las historias de egresados',
          },
          contact: {
            title: 'Ponte en Contacto',
            address: 'Dirección',
            addressDetails: 'Casa de la Información, Segundo Piso, Nairobi CBD',
            phone: 'Teléfono',
            email: 'Correo Electrónico',
            interestTitle: 'Expresa Tu Interés',
            interestText: '¿Interesado en unirte a nosotros? ¡Deja tus datos a continuación y te contactaremos!',
          },
          form: {
            name: 'Nombre',
            telephone: 'Teléfono',
            email: 'Correo Electrónico',
            nameRequired: 'El nombre es obligatorio',
            telephoneRequired: 'El teléfono es obligatorio',
            telephoneFormat: 'El teléfono debe estar en el formato +2547XXXXXXXX o +2541XXXXXXXX',
            emailRequired: 'El correo electrónico es obligatorio',
            emailInvalid: 'Dirección de correo electrónico inválida',
            submit: 'Enviar Interés',
            submitting: 'Enviando...',
            submitInterest: 'Enviar formulario de interés',
            success: '¡Gracias por tu interés!',
            successDetails: 'Nuestro equipo de admisiones te contactará pronto.',
            submitAnother: 'Enviar otra respuesta',
            error: 'No se pudo enviar. Por favor, intenta de nuevo más tarde.',
          },
          footer: {
            motto: 'Illuminatio et Salus Populi',
            quality: 'Proporcionando educación turística de calidad desde 1997',
            location: 'Ubicación y Contacto',
            address: 'Casa de la Información, Segundo Piso',
            nairobi: 'Nairobi CBD, Kenia',
            hours: 'Hora Actual',
            cookieSettings: 'Configuración de cookies',
            privacy: 'Aviso de privacidad',
            copyright: 'Colegio de Turismo San Tomas. Todos los derechos reservados.',
            admin: 'Panel de Administración',
            adminAria: 'Acceder al panel de administración',
          },
          nav: {
            home: 'Inicio',
            programs: 'Programas',
            campusLife: 'Vida en el Campus',
            alumni: 'Egresados',
            enrollment: 'Inscripción',
          },
          lang: {
            en: 'EN',
            sw: 'SW',
            fr: 'FR',
            es: 'ES',
          },
        },
      },
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['cookie'],
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;